export enum NotificationTypes {
  NewPost = "new_post",
  Friends = "friends",
  FriendsRequest = "friend-request",
  Like = "like",
  Comment = "comment",
  eventInvitation = "event-invitation",
  communityInvitation = "community-invitation",
  eventInvitationAccepted = "event-invitation-accepted",
  communityInvitationAccepted = "community-invitation-accepted",
  upComingEventDay = "upcoming-event",
  upComingEventHour = "upcoming-event-hour",
  upComingEventNow = "upcoming-event-now",
  eventDateUpdated = "event-date-updated",

}

export enum NotificationStatusTypes {
    NotRead = "not_read",
    Read = "read"
}